import { render, staticRenderFns } from "./suningEnterpriseCreditauthorize.vue?vue&type=template&id=7134d480&scoped=true"
import script from "./suningEnterpriseCreditauthorize.vue?vue&type=script&lang=js"
export * from "./suningEnterpriseCreditauthorize.vue?vue&type=script&lang=js"
import style0 from "./suningEnterpriseCreditauthorize.vue?vue&type=style&index=0&id=7134d480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7134d480",
  null
  
)

export default component.exports